"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryFetch = void 0;
const common_components_1 = require("@as-react/common-components");
const queryFetch_utils_1 = require("./queryFetch.utils");
const useQueryFetch = () => {
    const { servicesEndpoint } = (0, common_components_1.useAemConfig)();
    return (data, options) => (0, queryFetch_utils_1.queryFn)(data, options, servicesEndpoint);
};
exports.useQueryFetch = useQueryFetch;
//# sourceMappingURL=useQueryFetch.js.map